var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid search_cinci-module bg-black py-5" },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "row d-block d-sm-block d-md-block d-lg-none" },
            [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "global-header text-center" }, [
                  _c("h2", [_vm._v(_vm._s(_vm.paneldata.heading))]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "module-content",
                    domProps: { innerHTML: _vm._s(_vm.paneldata.content) },
                  }),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row sliders" }, [
            _c("div", { staticClass: "col-md-5 col-lg-5" }, [
              _c(
                "div",
                {
                  staticClass: "image-wrap glide glide-image",
                  staticStyle: { height: "100%" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "glide__track",
                      staticStyle: { height: "100%" },
                      attrs: { "data-glide-el": "track" },
                    },
                    [
                      _c(
                        "ul",
                        {
                          staticClass: "glide__slides mb-md-0",
                          staticStyle: { height: "100%" },
                        },
                        _vm._l(_vm.topicsdata, function (item, index) {
                          return _c(
                            "li",
                            {
                              key: "image_" + item.title + "_" + index,
                              staticClass: "glide__slide",
                            },
                            [
                              item.image.url
                                ? _c("img", {
                                    attrs: {
                                      src: item.image.url,
                                      alt: item.title,
                                    },
                                  })
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-7 col-lg-7 content-wrap" }, [
              _c(
                "div",
                {
                  staticClass:
                    "global-header d-none d-sm-none d-md-none d-lg-block",
                },
                [
                  _c("h2", [_vm._v(_vm._s(_vm.paneldata.heading))]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "module-content",
                    domProps: { innerHTML: _vm._s(_vm.paneldata.content) },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "glide glide-content" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "slider-content bg-plum mt-0 mt-sm-0 mt-md-4 mt-lg-5 p-3 glide__track",
                    attrs: { "data-glide-el": "track" },
                  },
                  [
                    _c(
                      "ul",
                      { staticClass: "glide__slides mb-md-0" },
                      _vm._l(_vm.topicsdata, function (item, index) {
                        return _c(
                          "li",
                          {
                            key: "content_" + item.title + "_" + index,
                            staticClass: "glide__slide slide",
                          },
                          [
                            _c("h3", [_vm._v(_vm._s(item.title))]),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "content",
                              domProps: { innerHTML: _vm._s(item.excerpt) },
                            }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-primary bg-mauve d-none d-sm-none d-md-inline-block",
                                attrs: { href: item.url },
                              },
                              [_vm._v("Explore " + _vm._s(item.title))]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "d-inline d-sm-inline d-md-none",
                                attrs: { href: item.url },
                              },
                              [_vm._v("Explore " + _vm._s(item.title))]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "glide-arrows d-none d-md-flex flex-row justify-content-start mt-3",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "prev d-flex flex-row justify-content-center align-items-center mr-3",
                      attrs: { id: "prev" },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "36px",
                            height: "21px",
                            viewBox: "0 0 24 14",
                            version: "1.1",
                            xmlns: "http://www.w3.org/2000/svg",
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          },
                        },
                        [
                          _c("title", [_vm._v("Previous Arrow")]),
                          _vm._v(" "),
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "Page-1",
                                stroke: "none",
                                "stroke-width": "1",
                                fill: "none",
                                "fill-rule": "evenodd",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "homepage",
                                    transform:
                                      "translate(-639.000000, -1367.000000)",
                                    fill: "#FFFFFF",
                                    "fill-rule": "nonzero",
                                  },
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "Arrow-to-left-by-Icons-Bazaar-from-the-Noun-Project",
                                        transform:
                                          "translate(639.000000, 1367.000000)",
                                      },
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "Group",
                                            transform:
                                              "translate(0.000000, 0.170825)",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d: "M6.92163043,0.088631687 C6.80272343,0.0992956367 6.6907857,0.149373042 6.60358696,0.230914296 L0.17576087,6.12308821 C0.0633038102,6.22465908 -0.000874988537,6.36910631 -0.000874988537,6.52064256 C-0.000874988537,6.6721788 0.0633038102,6.81662603 0.17576087,6.9181969 L6.60358696,12.8103708 C6.74547197,12.9399304 6.94582879,12.9836808 7.1288056,12.9250589 C7.31178241,12.8664371 7.44941382,12.7144024 7.48959483,12.5265127 C7.52977585,12.338623 7.46636537,12.1435947 7.32336957,12.0152621 L1.91663043,7.06047951 L23.0330435,7.06047951 C23.3160352,7.0644969 23.5770652,6.80783917 23.5770652,6.52482734 C23.5770652,6.24181551 23.3160352,5.98518456 23.0330435,5.98917517 L1.91663043,5.98917517 L7.32336957,1.02602299 C7.49879856,0.87327778 7.55561094,0.624778214 7.4639822,0.410977824 C7.37235346,0.197177434 7.15322455,0.0669384219 6.92163043,0.088631687 Z",
                                              id: "Path",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "next d-flex flex-row justify-content-center align-items-center",
                      attrs: { id: "next" },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "36px",
                            height: "21px",
                            viewBox: "0 0 24 14",
                            version: "1.1",
                            xmlns: "http://www.w3.org/2000/svg",
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          },
                        },
                        [
                          _c("title", [_vm._v("Next Story")]),
                          _vm._v(" "),
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "Page-1",
                                stroke: "none",
                                "stroke-width": "1",
                                fill: "none",
                                "fill-rule": "evenodd",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "homepage",
                                    transform:
                                      "translate(-639.000000, -1367.000000)",
                                    fill: "#FFFFFF",
                                    "fill-rule": "nonzero",
                                  },
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "Arrow-to-left-by-Icons-Bazaar-from-the-Noun-Project",
                                        transform:
                                          "translate(639.000000, 1367.000000)",
                                      },
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "Group",
                                            transform:
                                              "translate(0.000000, 0.170825)",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d: "M6.92163043,0.088631687 C6.80272343,0.0992956367 6.6907857,0.149373042 6.60358696,0.230914296 L0.17576087,6.12308821 C0.0633038102,6.22465908 -0.000874988537,6.36910631 -0.000874988537,6.52064256 C-0.000874988537,6.6721788 0.0633038102,6.81662603 0.17576087,6.9181969 L6.60358696,12.8103708 C6.74547197,12.9399304 6.94582879,12.9836808 7.1288056,12.9250589 C7.31178241,12.8664371 7.44941382,12.7144024 7.48959483,12.5265127 C7.52977585,12.338623 7.46636537,12.1435947 7.32336957,12.0152621 L1.91663043,7.06047951 L23.0330435,7.06047951 C23.3160352,7.0644969 23.5770652,6.80783917 23.5770652,6.52482734 C23.5770652,6.24181551 23.3160352,5.98518456 23.0330435,5.98917517 L1.91663043,5.98917517 L7.32336957,1.02602299 C7.49879856,0.87327778 7.55561094,0.624778214 7.4639822,0.410977824 C7.37235346,0.197177434 7.15322455,0.0669384219 6.92163043,0.088631687 Z",
                                              id: "Path",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row d-flex d-sm-flex d-md-none" }, [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                {
                  staticClass:
                    "glide-arrows d-flex flex-row justify-content-center mt-3",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "prev d-flex flex-row justify-content-center align-items-center mr-3",
                      attrs: { id: "mobileprev" },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "36px",
                            height: "21px",
                            viewBox: "0 0 24 14",
                            version: "1.1",
                            xmlns: "http://www.w3.org/2000/svg",
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          },
                        },
                        [
                          _c("title", [_vm._v("Previous Story")]),
                          _vm._v(" "),
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "Page-1",
                                stroke: "none",
                                "stroke-width": "1",
                                fill: "none",
                                "fill-rule": "evenodd",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "homepage",
                                    transform:
                                      "translate(-639.000000, -1367.000000)",
                                    fill: "#FFFFFF",
                                    "fill-rule": "nonzero",
                                  },
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "Arrow-to-left-by-Icons-Bazaar-from-the-Noun-Project",
                                        transform:
                                          "translate(639.000000, 1367.000000)",
                                      },
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "Group",
                                            transform:
                                              "translate(0.000000, 0.170825)",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d: "M6.92163043,0.088631687 C6.80272343,0.0992956367 6.6907857,0.149373042 6.60358696,0.230914296 L0.17576087,6.12308821 C0.0633038102,6.22465908 -0.000874988537,6.36910631 -0.000874988537,6.52064256 C-0.000874988537,6.6721788 0.0633038102,6.81662603 0.17576087,6.9181969 L6.60358696,12.8103708 C6.74547197,12.9399304 6.94582879,12.9836808 7.1288056,12.9250589 C7.31178241,12.8664371 7.44941382,12.7144024 7.48959483,12.5265127 C7.52977585,12.338623 7.46636537,12.1435947 7.32336957,12.0152621 L1.91663043,7.06047951 L23.0330435,7.06047951 C23.3160352,7.0644969 23.5770652,6.80783917 23.5770652,6.52482734 C23.5770652,6.24181551 23.3160352,5.98518456 23.0330435,5.98917517 L1.91663043,5.98917517 L7.32336957,1.02602299 C7.49879856,0.87327778 7.55561094,0.624778214 7.4639822,0.410977824 C7.37235346,0.197177434 7.15322455,0.0669384219 6.92163043,0.088631687 Z",
                                              id: "Path",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "next d-flex flex-row justify-content-center align-items-center",
                      attrs: { id: "mobilenext" },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "36px",
                            height: "21px",
                            viewBox: "0 0 24 14",
                            version: "1.1",
                            xmlns: "http://www.w3.org/2000/svg",
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          },
                        },
                        [
                          _c("title", [_vm._v("Next Story")]),
                          _vm._v(" "),
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "Page-1",
                                stroke: "none",
                                "stroke-width": "1",
                                fill: "none",
                                "fill-rule": "evenodd",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "homepage",
                                    transform:
                                      "translate(-639.000000, -1367.000000)",
                                    fill: "#FFFFFF",
                                    "fill-rule": "nonzero",
                                  },
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "Arrow-to-left-by-Icons-Bazaar-from-the-Noun-Project",
                                        transform:
                                          "translate(639.000000, 1367.000000)",
                                      },
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            id: "Group",
                                            transform:
                                              "translate(0.000000, 0.170825)",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d: "M6.92163043,0.088631687 C6.80272343,0.0992956367 6.6907857,0.149373042 6.60358696,0.230914296 L0.17576087,6.12308821 C0.0633038102,6.22465908 -0.000874988537,6.36910631 -0.000874988537,6.52064256 C-0.000874988537,6.6721788 0.0633038102,6.81662603 0.17576087,6.9181969 L6.60358696,12.8103708 C6.74547197,12.9399304 6.94582879,12.9836808 7.1288056,12.9250589 C7.31178241,12.8664371 7.44941382,12.7144024 7.48959483,12.5265127 C7.52977585,12.338623 7.46636537,12.1435947 7.32336957,12.0152621 L1.91663043,7.06047951 L23.0330435,7.06047951 C23.3160352,7.0644969 23.5770652,6.80783917 23.5770652,6.52482734 C23.5770652,6.24181551 23.3160352,5.98518456 23.0330435,5.98917517 L1.91663043,5.98917517 L7.32336957,1.02602299 C7.49879856,0.87327778 7.55561094,0.624778214 7.4639822,0.410977824 C7.37235346,0.197177434 7.15322455,0.0669384219 6.92163043,0.088631687 Z",
                                              id: "Path",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row topics_shelf mt-3 mt-sm-3 mt-md-5" }, [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                {
                  staticClass:
                    "topics d-flex flex-row flex-wrap justify-content-start",
                  attrs: { "data-glide-el": "controls[nav]" },
                },
                _vm._l(_vm.topicsdata, function (item, index) {
                  return _c(
                    "a",
                    {
                      key: item.title,
                      staticClass: "topic w-25 mt-3",
                      attrs: {
                        href: item.url,
                        "data-index": index,
                        "data-glide-dir": "=" + index,
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "topic-thumb",
                        attrs: { src: item.thumbnail, alt: "Topic Thumbnail" },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "topic-title mt-1" }, [
                        _vm._v(_vm._s(item.title)),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }